import { z } from 'zod';

export const campaignSchema = z.object({
  id: z.number(),
  name: z.string(),
  advertiserName: z.string(),
  advertiserTeamName: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  reportDates: z.array(z.string()),
  channels: z.array(z.string()),
  adSpend: z.number(),
  salesEnabled: z.boolean(),
  salesRequested: z.boolean(),
  archived: z.boolean(),
  latestReportStatus: z.enum(['pending', 'approved']),
  accountManagerIds: z.array(z.number()),
  podIds: z.array(z.number()),
  brand: z.string().nullable(),
  youtubeMeasurementEnabled: z.boolean(),
  locationListId: z.number(),
});

export const campaignsResponseSchema = z.object({
  campaigns: z.array(campaignSchema),
  total: z.number(),
});

export type Campaign = z.infer<typeof campaignSchema>;
export type CampaignsResponseSchema = z.infer<typeof campaignsResponseSchema>;
